export const GRANTAUTHORITY = {
  GRANTAUTHORITYLISTS: 'grant_authority_lists',
  SEARCHUSERLIST: 'authority_search_list',
};
